import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackChangedVideoPlaybackRate.meta';

export type TrackChangedVideoPlaybackRateParams = {
  id: string;
  speed: number;
};

export const useTrackChangedVideoPlaybackRate = () => {
  const { track } = useAnalyticsUtilities();

  const trackChangedVideoPlaybackRate = useCallback(
    (params: TrackChangedVideoPlaybackRateParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackChangedVideoPlaybackRate };
};
